// extracted by mini-css-extract-plugin
module.exports = {"title":"Card_title__Sirhd","produto":"Card_produto__33swh"};